import type {
  LearningAdviceResult,
  LongSentenceItemView,
  Paginated,
  SentenceAnalysisResult,
  StudyMode,
} from '@en3/shared';
import { api } from './client';
import { toQuery } from './content.api';

/**
 * 长难句与学习建议接口（阶段 5 / 7）。
 *
 * 关于 `analyze` 的两种入口：
 * - 阅读页手里有 `sentenceId`（数据库里的句子 id）→ 传它，结果会被缓存并写回句子行；
 * - 长难句页/用户粘贴的一句话 → 传 `text`，同样会走缓存（按文本哈希），但不落句子行。
 * 两者都不要在前端做任何解析：解析逻辑在 shared（规则）与后端（AI）里，只有一份。
 */

export const analysisApi = {
  analyze: (input: { sentenceId?: string; articleId?: string; globalIndex?: number; text?: string; force?: boolean }) =>
    api.post<SentenceAnalysisResult>('/api/sentences/analyze', input),

  longSentences: (params: { page?: number; pageSize?: number; articleId?: string; unanalyzed?: boolean; sort?: 'score' | 'recent' } = {}) =>
    api.get<Paginated<LongSentenceItemView>>(
      `/api/long-sentences${toQuery({ ...params, unanalyzed: params.unanalyzed ? 1 : undefined })}`,
    ),

  advice: (articleId: string, params: { mode?: StudyMode; force?: boolean } = {}) =>
    api.get<LearningAdviceResult>(
      `/api/learning-advice/${articleId}${toQuery({ mode: params.mode, force: params.force ? 1 : undefined })}`,
    ),
};
